module.exports = __webpack_public_path__ + "static/media/Container.c6e65f77.png";